import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      height: "100vh",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    flex: "0 0 68px",
    padding: 16,
    background: theme.palette.grey[100],
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  title: {
    flex: 1,
  },
  chart: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    height: "100vw",
    padding: 24,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    [theme.breakpoints.up("md")]: {
      flex: "1",
      order: 2,
      height: "initial",
    },
  },
  chartTitle: {
    display: "none",
    position: "absolute",
    top: 24,
    left: 40,
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  closeMobile: {
    color: theme.palette.grey[700],
  },
  closeDesktop: {
    display: "none",
    position: "absolute",
    top: 24,
    right: 24,
    color: theme.palette.grey[900],
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  list: {
    flex: "1",
    padding: "8px 16px",
    [theme.breakpoints.up("md")]: {
      flex: "0 0 350px",
      order: 1,
      padding: 24,
      background: theme.palette.grey[100],
      borderRadius: "0 20px 0 0",
      overflowY: "auto",
    },
  },
  listHeader: {
    display: "none",
    marginBottom: 8,
    paddingBottom: 20,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
}));
